export const UPDATE_EDOK_FORM_FAILURE = 'UPDATE_EDOK_FORM_FAILURE';

export const updateEdokFormFailure = error => ({
    type: UPDATE_EDOK_FORM_FAILURE,
    payload: error,
    error: true,
});
